module.exports = __webpack_public_path__ + "img/logo.4df1d61f.png";